import { useInstallPrompt } from '../hooks/useInstallPrompt';
import { Button } from './Button';
import styles from './InstallAppButton.module.css';

/**
 * Lets a visitor install WhaleTail as a PWA (home-screen icon, standalone
 * window, and — critically for iOS — the prerequisite for push notification
 * permission, which iOS Safari refuses to grant from a plain browser tab).
 * Renders nothing once already installed. On Chromium/Android/desktop this
 * triggers the real native install prompt; iOS has no such API, so there we
 * show instructions instead of a button.
 */
export function InstallAppButton() {
  const { state, promptInstall } = useInstallPrompt();

  if (state === 'unavailable' || state === 'installed') return null;

  if (state === 'ios-manual') {
    return (
      <p className={styles.hint}>
        To install: tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.
      </p>
    );
  }

  return (
    <Button type="button" onClick={promptInstall}>
      Install WhaleTail
    </Button>
  );
}
